import {
    CROSS_CONFIG_STATES,
    CROSS_CONFIG_CITIES,
    CROSS_CONFIG_GALLERIES,
    CROSS_CONFIG_AGENCIES
} from '../actions/constants'

const defaultState = {
    states: [],
    cities: [],
    userAgencies: [],
    userGalleries: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CROSS_CONFIG_STATES:
            return {
                ...state,
                states: action.payload
            };
        case CROSS_CONFIG_CITIES:
            return {
                ...state,
                cities: action.payload
            };
        case CROSS_CONFIG_AGENCIES:
            return {
                ...state,
                userAgencies: action.payload
            };
        case CROSS_CONFIG_GALLERIES:
            return {
                ...state,
                userGalleries: action.payload
            };
        default:
            return state;
    }
};